import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'swb-partners',
    templateUrl: './partners.component.html'
})
export class PartnersComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
